import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getAuthToken } from './authToken';

const auth = () => ({ Authorization: 'Bearer ' + getAuthToken() });
const inp: any = { width: '100%', padding: '7px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, boxSizing: 'border-box' };
const lbl: any = { fontSize: 12, color: '#6b7280', marginBottom: 4 };

const EMPTY: any = { seller_name: '', seller_nip: '', seller_street: '', seller_zip: '', seller_city: '', seller_country: 'Polska',
  seller_email: '', seller_phone: '', vat_rate: '23', bank_account_id: '', payment_days: 7, notes: '' };

export default function ProformaSettings({ API }: { API: string }) {
  const [f, setF] = useState<any>(EMPTY);
  const [rates, setRates] = useState<string[]>(['23', '8', '5', '0', 'zw']);
  const [accounts, setAccounts] = useState<any[]>([]);
  const [loaded, setLoaded] = useState(false);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<{ ok: boolean; text: string } | null>(null);

  useEffect(() => {
    axios.get(API + '/settings/proforma', { headers: auth() })
      .then((r: any) => {
        setF({ ...EMPTY, ...((r.data && r.data.settings) || {}) });
        if (r.data && Array.isArray(r.data.vat_rates)) setRates(r.data.vat_rates);
        setAccounts((r.data && r.data.bank_accounts) || []);
      })
      .catch((e: any) => setMsg({ ok: false, text: String((e.response && e.response.data && e.response.data.detail) || 'Nie udało się wczytać ustawień.') }))
      .finally(() => setLoaded(true));
  }, [API]);

  const set = (k: string) => (e: any) => setF((x: any) => ({ ...x, [k]: e.target.value }));
  const save = () => {
    setBusy(true); setMsg(null);
    axios.post(API + '/settings/proforma', { ...f, payment_days: Number(f.payment_days) || 0 }, { headers: auth() })
      .then((r: any) => { setF({ ...EMPTY, ...((r.data && r.data.settings) || f) }); setMsg({ ok: true, text: 'Zapisano.' }); })
      .catch((e: any) => setMsg({ ok: false, text: String((e.response && e.response.data && e.response.data.detail) || 'Nie udało się zapisać.') }))
      .finally(() => setBusy(false));
  };

  if (!loaded) return <div style={{ fontSize: 13, color: '#6b7280' }}>Wczytywanie…</div>;
  const field = (k: string, label: string, ph?: string) => (
    <div><div style={lbl}>{label}</div><input value={f[k] || ''} onChange={set(k)} placeholder={ph || ''} style={inp} /></div>
  );
  return (
    <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 16, maxWidth: 720 }}>
      <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 6 }}>Faktura proforma</div>
      <div style={{ fontSize: 13, color: '#374151', marginBottom: 12 }}>
        Dane sprzedawcy na proformie. Proformę wystawisz w szczegółach zamówienia przyciskiem „📄 Proforma”. Proforma nie jest dokumentem księgowym i nie trafia do KSeF.
      </div>
      {msg ? <div style={{ background: msg.ok ? '#f0fdf4' : '#fef2f2', border: '1px solid ' + (msg.ok ? '#bbf7d0' : '#fecdd3'), color: msg.ok ? '#15803d' : '#b91c1c', borderRadius: 8, padding: '8px 12px', fontSize: 13, marginBottom: 10 }}>{msg.ok ? '✓ ' : '✕ '}{msg.text}</div> : null}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 10, marginBottom: 10 }}>
        {field('seller_name', 'Nazwa firmy *')}
        {field('seller_nip', 'NIP *', 'np. 5250001009')}
        {field('seller_street', 'Ulica i numer')}
        {field('seller_zip', 'Kod pocztowy', '00-000')}
        {field('seller_city', 'Miejscowość')}
        {field('seller_country', 'Kraj')}
        {field('seller_email', 'E-mail')}
        {field('seller_phone', 'Telefon')}
        <div><div style={lbl}>Stawka VAT</div>
          <select value={f.vat_rate} onChange={set('vat_rate')} style={inp}>
            {rates.map((r) => <option key={r} value={r}>{r === 'zw' ? 'zw. (zwolniony)' : r + '%'}</option>)}
          </select>
        </div>
        <div><div style={lbl}>Termin płatności (dni)</div><input type="number" min={0} max={365} value={f.payment_days} onChange={set('payment_days')} style={inp} /></div>
        <div style={{ gridColumn: '1 / -1' }}><div style={lbl}>Konto bankowe na proformie</div>
          <select value={f.bank_account_id || ''} onChange={set('bank_account_id')} style={inp}>
            <option value="">— konto domyślne firmy (albo konto wybrane w zamówieniu) —</option>
            {accounts.map((a: any) => <option key={a.id} value={a.id}>{String(a.number || '')}{a.description ? ' · ' + String(a.description) : ''}</option>)}
          </select>
          {!accounts.length ? <div style={{ fontSize: 12, color: '#b45309', marginTop: 4 }}>Brak zapisanych kont bankowych — dodasz je w Ustawienia → Moje konto.</div> : null}
        </div>
        <div style={{ gridColumn: '1 / -1' }}><div style={lbl}>Uwagi na proformie (opcjonalnie)</div>
          <textarea value={f.notes || ''} onChange={set('notes')} rows={2} style={{ ...inp, resize: 'vertical' }} />
        </div>
      </div>
      <button onClick={save} disabled={busy}
        style={{ padding: '7px 16px', borderRadius: 6, border: '1px solid #1d4ed8', background: '#1d4ed8', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer', opacity: busy ? 0.5 : 1 }}>{busy ? 'Zapisywanie…' : 'Zapisz'}</button>
    </div>
  );
}
